import { FC, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { platform } from 'network-utils';
import { translate } from 'translations';
import { showAlert } from '@redux/slices/informationSlice';
import { useDispatch, useSelector } from 'react-redux';
import { LearningPanelDialog } from 'learning-panel-components';
import { useNavigate } from 'react-router-dom';
import { getUserInfoKey } from '@queries/platform/login';
import { selectUserId } from '@redux/slices/userSlice';

const DeleteAccountContainer: FC = () => {
    const [showDeleteUserDialog, setShowDeleteUserDialog] = useState<boolean>(false);
    const services = platform.LoginApi;
    const failedToDeleteUserMsg = translate('failedToDeleteUser');
    const userId = useSelector(selectUserId);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const showError = (error: string) => {
        dispatch(
            showAlert({
                value: error,
                status: 'error'
            })
        );
    };

    const deleteAccount = async (): Promise<any> => {
        return services.deleteUser();
    };

    const { mutate } = useMutation(deleteAccount, {
        onSuccess: updateLocaleResponse => {
            if (updateLocaleResponse?.json?.status === 200) {
                setShowDeleteUserDialog(false);
                navigate('/app/login');
                queryClient.invalidateQueries([getUserInfoKey, userId]);
                return;
            }
            showError(failedToDeleteUserMsg);
        },
        onError: () => {
            showError(failedToDeleteUserMsg);
        }
    });

    return (
        <>
            <div onClick={() => setShowDeleteUserDialog(true)}>
                <div>{translate('DeleteAccount')}</div>
            </div>
            {showDeleteUserDialog && (
                <LearningPanelDialog
                    open={showDeleteUserDialog}
                    title={translate('DeleteUser')}
                    subTitle={translate('DeleteUserTitle')}
                    content={translate('DeleteUserBody')}
                    onClose={() => setShowDeleteUserDialog(false)}
                    okButtonOnClick={mutate}
                    okButtonText={translate('Delete')}
                    cancelButtonOnClick={() => setShowDeleteUserDialog(false)}
                    cancelButtonText={translate('Cancel')}
                />
            )}
        </>
    );
};

export default DeleteAccountContainer;
